import axios from 'axios';

const prefix = '/StockProductInfo/ImageImport';
// 队列自行展示进度和逐图错误，避免通用拦截器弹出成百条提示或干扰全屏加载计数。
const client = axios.create({ baseURL: process.env.VUE_APP_BASEURL, timeout: 240000 });
async function request(config) {
  try {
    const response = await client.request({ ...config, headers: {
      Authorization: (sessionStorage.getItem('token_type') || '') + ' ' + (sessionStorage.getItem('access_token') || '')
    } });
    if (response.data?.code !== 200) throw new Error(response.data?.content || '请求失败，请重试');
    return response.data;
  } catch (error) {
    const status = error.response?.status;
    const message = { 401: '登录已过期，请重新登录', 403: '无权限维护SPU图片', 413: '图片超过服务器允许的上传大小' }[status]
      || (error.code === 'ECONNABORTED' ? '上传超时，请重试' : error.response?.data?.content)
      || (axios.isAxiosError(error) && !error.response ? '网络连接中断，请检查网络后重试' : error.message)
      || '请求失败，请重试';
    throw Object.assign(new Error(message), { status });
  }
}
export function matchSpuImages(files) {
  return request({ url: prefix + '/Match', method: 'post', data: { files } });
}
export function searchImageSpus(keyword, page = 1) {
  return request({ url: prefix + '/Spus', method: 'get', params: { keyword, page, pageSize: 20 } });
}
export function uploadSpuImage(item, onProgress) {
  const data = new FormData();
  data.append('file', item.file);
  data.append('fileId', item.fileId);
  data.append('uploadToken', item.uploadToken);
  data.append('spuId', item.spu.id);
  data.append('isCover', String(!!item.isCover));
  return request({
    url: prefix + '/Upload', method: 'post', data,
    onUploadProgress: event => onProgress(event.total ? Math.round(event.loaded * 100 / event.total) : 0)
  });
}
